import React, { useEffect } from "react";
// import BackgroundBrundcrumb from "../../assets/images/IZB/BackgroundBrundcrumb.png";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import BriefHistory from "../../Components/BriefHistory/BriefHistory";
import Vision from "../../Components/Vision/Vision";
import CoreValues from "../../Components/CoreValues/CoreValues";


import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";

const AboutUs = () => {
  const ShareHolders = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Shareholders.jpg";
const BriefHistoryImg = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Kenneth-Kaunda-Indira-Gandhi.jpg";
const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/BackgroundBrundcrumb.png";


const CoreValueIcon1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/our-core-value-1.png"
const CoreValueIcon2 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/our-core-value-2.png"
const CoreValueIcon3 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/our-core-value-3.png"
const CoreValueIcon4 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/our-core-value-4.png"
const CoreValueIcon5 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/our-core-value-5.png"
const CoreValueIcon6 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/our-core-value-6.png"

  const path = [
    { label: "Home", url: "/" },
    { label: "About US", url: "/AboutUS" },
  ];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb Heading="About Us" img={BackgroundBrundcrumb} paths={path} />
      <BriefHistory
        heading="Brief History"
        content="Indo Zambia Bank was formed on 19th October, 1984 by the Government of the Republic of Zambia and the Government of India out of the desire to promote banking facilities to support the economic development of Zambia."
        image={BriefHistoryImg}
      />
      <Vision />

      <section className="container">
        <div className="custom-plain-card">
          <h6>ENVIRONMENTAL, SOCIAL, AND GOVERNANCE STATEMENT</h6>
          <p>At Indo Zambia Bank Limited, we are committed to being custodians of the environment, promoting social equity, and upholding sound governance practices. We believe that implementing Environmental, Social, and Governance (ESG) factors into our decision- making processes is not only the correct thing to do but also contributes to our financial institution's long-term success as it pursues its mission of creating value for all stakeholders.
          </p>
          <p>The formation of this joint venture Bank was fostered by the long and deep ties of friendship and the ever-growing trade ties between India and Zambia.</p>
        </div>
      </section>


      <section className="about-core-values">
        <div className="container">
            <h2 className="text-center mb-5">Our Core Values</h2>

            <ul className="core-values-list">
              <li>
                <div className="core-values-list_icon">
                  <img src={CoreValueIcon1} alt="" srcset="" />
                </div>
                <div className="core-values-list_content">
                  <p className="title">Service Commitment
                  </p>
                  <p className="desc">To deliver quality and reliable service to our customers and the entire nation, 
                  enabling economic growth and development.</p>
                </div>
              </li>
              <li>
                <div className="core-values-list_icon">
                  <img src={CoreValueIcon2} alt="" srcset="" />
                </div>
                <div className="core-values-list_content">
                  <p className="title">Accountability</p>
                  <p className="desc">Commitment to account to all our Stakeholders by operating in a safe and sound manner 
                  with compliance to laws and regulations.</p>
                </div>
              </li>
              <li>
                <div className="core-values-list_icon">
                  <img src={CoreValueIcon3} alt="" srcset="" />
                </div>
                <div className="core-values-list_content">
                  <p className="title">Integrity</p>
                  <p className="desc">Commitment to the highest level of ethical moral standards and transparency.</p>
                </div>
              </li>
              <li>
                <div className="core-values-list_icon">
                  <img src={CoreValueIcon4} alt="" srcset="" />
                </div>
                <div className="core-values-list_content">
                  <p className="title">Responsibility</p>
                  <p className="desc">Commitment to supporting the communities in which we operate.</p>
                </div>
              </li>
              <li>
                <div className="core-values-list_icon">
                  <img src={CoreValueIcon5} alt="" srcset="" />
                </div>
                <div className="core-values-list_content">
                  <p className="title">Commitment</p>
                  <p className="desc">Commitment to embracing our diversity, attracting, motivating and retaining 
                  the best people being our competitive advantage.</p>
                </div>
              </li>
              <li>
                <div className="core-values-list_icon">
                  <img src={CoreValueIcon6} alt="" srcset="" />
                </div>
                <div className="core-values-list_content">
                  <p className="title">Professionalism</p>
                  <p className="desc">Commitment to act with utmost professionalism in all our workings.</p>
                </div>
              </li>
            </ul>
        </div>
      </section>

      {/* <CoreValues /> */}
      <div className="container mb-5">
        <div className="heading py-5">
          <h2 className="text-center">Shareholders of the bank</h2>
        </div>
        <div className="d-flex justify-content-center">
          <img src={ShareHolders} width="100%" alt="" />
        </div>
      </div>
      <AllAcountsSection />
    </>
  );
};

export default AboutUs;
